/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Proprietary code. Licensed, not sold. See LICENSE.md and Services Agreement.
 */
/**
 * FOIL WING COVER SELECTOR V1.0
 *
 * Dependencies (from Liquid):
 *   #foilcoverProductData  - JSON script tag with product array
 *   #foilcoverSettings     - JSON script tag with section settings
 */
(function () {
  "use strict";

  var products = [];
  var settings = {};
  var state = { wingspan: 60, ratio: "High-aspect", hasSearched: false };
  var el = {};
  var guideA11yState = null;

  function cacheElements() {
    el.wingspanSlider = document.getElementById("fcWingspanSlider");
    el.wingspanDisplay = document.getElementById("fcWingspanDisplay");
    el.wingspanDirect = document.getElementById("fcWingspanDirect");
    el.wingspanFill = document.getElementById("fcWingspanFill");
    el.wingspanStep = document.getElementById("fcWingspanStep");
    el.wingspanQuick = document.getElementById("fcWingspanQuick");
    el.wingspanTooltip = document.getElementById("fcWingspanTooltip");
    el.wingspanSliderZone = document.getElementById("fcWingspanSliderZone");
    el.wingspanEditBtn = document.getElementById("fcWingspanEditBtn");
    el.findBtn = document.getElementById("fcFindBtn");
    el.resetBtn = document.getElementById("fcResetBtn");
    el.results = document.getElementById("fcResults");
    el.resultsGrid = document.getElementById("fcResultsGrid");
    el.resultsSummary = document.getElementById("fcResultsSummary");
    el.placeholder = document.getElementById("fcPlaceholder");
    el.helpBtn = document.getElementById("fcHelpBtn");
    el.guideModal = document.getElementById("fcGuideModal");
    el.guideBackdrop = document.getElementById("fcGuideBackdrop");
    el.guideClose = document.getElementById("fcGuideClose");
  }

  function loadData() {
    var dataEl = document.getElementById("foilcoverProductData");
    var settingsEl = document.getElementById("foilcoverSettings");
    if (dataEl) products = JSON.parse(dataEl.textContent);
    if (settingsEl) settings = JSON.parse(settingsEl.textContent);
    state.wingspan = settings.wingspanDefault || 60;
  }

  /* ---------------------------------------------------------------
   * Initialization
   * --------------------------------------------------------------- */
  function init() {
    loadData();
    cacheElements();
    if (!el.wingspanSlider) return;

    state.wingspan = parseInt(el.wingspanSlider.value, 10);

    bindRatioPills();
    bindSlider();
    bindDirectInput();
    bindEditButton();
    bindGuideModal();
    el.findBtn.addEventListener("click", findCovers);
    el.resetBtn.addEventListener("click", reset);
    updateFill();
    positionTooltip();
    buildQuickButtons();
  }

  /* ---------------------------------------------------------------
   * Aspect ratio pills
   * --------------------------------------------------------------- */
  var ratioPills;

  function bindRatioPills() {
    ratioPills = document.querySelectorAll(".aspect-ratio__pill");
    ratioPills.forEach(function (pill) {
      pill.setAttribute("aria-pressed", pill.classList.contains("is-active") ? "true" : "false");
      pill.addEventListener("click", function () {
        ratioPills.forEach(function (p) {
          p.classList.remove("is-active");
          p.setAttribute("aria-pressed", "false");
        });
        pill.classList.add("is-active");
        pill.setAttribute("aria-pressed", "true");
        state.ratio = pill.dataset.ratio;
        buildQuickButtons();
        if (state.hasSearched) findCovers();
      });
    });
  }

  /* ---------------------------------------------------------------
   * Tooltip
   * --------------------------------------------------------------- */
  function positionTooltip() {
    var slider = el.wingspanSlider;
    var min = parseInt(slider.min, 10);
    var max = parseInt(slider.max, 10);
    var val = parseInt(slider.value, 10);
    var pct = ((val - min) / (max - min)) * 100;
    el.wingspanTooltip.textContent = val + " cm";
    el.wingspanTooltip.style.left = pct + "%";
  }

  /* ---------------------------------------------------------------
   * Slider
   * --------------------------------------------------------------- */
  function bindSlider() {
    var zone = el.wingspanSliderZone;

    el.wingspanSlider.addEventListener("input", function () {
      state.wingspan = parseInt(this.value, 10);
      updateDisplay();
      positionTooltip();
      if (state.hasSearched) findCovers();
    });

    el.wingspanSlider.addEventListener("mousedown", function () {
      zone.classList.add("is-dragging");
    });
    el.wingspanSlider.addEventListener(
      "touchstart",
      function () {
        zone.classList.add("is-dragging");
      },
      { passive: true },
    );
    document.addEventListener("mouseup", function () {
      zone.classList.remove("is-dragging");
    });
    document.addEventListener("touchend", function () {
      zone.classList.remove("is-dragging");
    });
  }

  /* ---------------------------------------------------------------
   * Direct input
   * --------------------------------------------------------------- */
  function bindDirectInput() {
    var direct = el.wingspanDirect;
    var min = parseInt(el.wingspanSlider.min, 10);
    var max = parseInt(el.wingspanSlider.max, 10);

    direct.addEventListener("change", function () {
      var val = Math.max(min, Math.min(max, parseInt(this.value, 10)));
      state.wingspan = val;
      el.wingspanSlider.value = val;
      this.value = val;
      updateDisplay();
      el.wingspanStep.classList.remove("is-editing");
      if (state.hasSearched) findCovers();
    });

    direct.addEventListener("keydown", function (e) {
      if (e.key === "Enter") this.blur();
    });
  }

  /* ---------------------------------------------------------------
   * Edit button
   * --------------------------------------------------------------- */
  function bindEditButton() {
    el.wingspanEditBtn.addEventListener("click", function () {
      el.wingspanStep.classList.toggle("is-editing");
      if (el.wingspanStep.classList.contains("is-editing")) {
        el.wingspanDirect.focus();
        el.wingspanDirect.select();
      }
    });
  }

  /* ---------------------------------------------------------------
   * Guide modal
   * --------------------------------------------------------------- */
  function bindGuideModal() {
    if (!el.helpBtn || !el.guideModal) return;

    el.helpBtn.addEventListener("click", function () {
      el.guideModal.removeAttribute("hidden");
      el.guideModal.classList.add("is-open");
      el.guideModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      var a11y = window.UnifiberModalA11y;
      if (a11y) {
        guideA11yState = a11y.activate({
          roots: el.guideModal,
          trigger: el.helpBtn,
          focusTarget: el.guideClose,
        });
      } else if (el.guideClose) {
        el.guideClose.focus();
      }
    });

    function closeGuide() {
      el.guideModal.classList.remove("is-open");
      el.guideModal.setAttribute("hidden", "");
      el.guideModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";

      var a11y = window.UnifiberModalA11y;
      if (a11y && guideA11yState) {
        a11y.deactivate(guideA11yState);
        guideA11yState = null;
      }
    }

    el.guideClose.addEventListener("click", closeGuide);
    el.guideBackdrop.addEventListener("click", closeGuide);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && el.guideModal.classList.contains("is-open")) closeGuide();
    });
  }

  /* ---------------------------------------------------------------
   * Quick select buttons
   * --------------------------------------------------------------- */
  function buildQuickButtons() {
    el.wingspanQuick.textContent = "";
    var filtered = products.filter(function (c) {
      return c.aspectRatio === state.ratio;
    });
    filtered.forEach(function (cover) {
      var btn = document.createElement("button");
      btn.className = "dimension-input__quick-btn";
      btn.type = "button";
      btn.textContent = cover.wingspanMin + "-" + cover.wingspanMax;
      btn.dataset.value = String(Math.round((cover.wingspanMin + cover.wingspanMax) / 2));
      btn.dataset.min = cover.wingspanMin;
      btn.dataset.max = cover.wingspanMax;
      btn.addEventListener("click", function () {
        state.wingspan = parseInt(btn.dataset.value, 10);
        el.wingspanSlider.value = state.wingspan;
        updateDisplay();
        positionTooltip();
        if (state.hasSearched) findCovers();
      });
      el.wingspanQuick.appendChild(btn);
    });
    updateQuickHighlight();
  }

  function updateQuickHighlight() {
    var val = state.wingspan;
    el.wingspanQuick.querySelectorAll(".dimension-input__quick-btn").forEach(function (btn) {
      var min = parseInt(btn.dataset.min, 10);
      var max = parseInt(btn.dataset.max, 10);
      var isActive = val >= min && val <= max;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateDisplay() {
    el.wingspanDisplay.textContent = state.wingspan;
    el.wingspanDirect.value = state.wingspan;
    updateFill();
    updateQuickHighlight();
  }

  function updateFill() {
    var slider = el.wingspanSlider;
    var min = parseInt(slider.min, 10);
    var max = parseInt(slider.max, 10);
    var pct = ((parseInt(slider.value, 10) - min) / (max - min)) * 100;
    el.wingspanFill.style.width = pct + "%";
  }

  /* ---------------------------------------------------------------
   * Find covers
   * --------------------------------------------------------------- */
  function findCovers() {
    var w = state.wingspan;
    var ratio = state.ratio;
    var ratioLabel = ratio.replace("-", " ");

    var filtered = products.filter(function (c) {
      return c.aspectRatio === ratio;
    });

    var scored = filtered.map(function (cover) {
      var mid = (cover.wingspanMin + cover.wingspanMax) / 2;
      var isExact = w >= cover.wingspanMin && w <= cover.wingspanMax;
      var diff = Math.abs(mid - w);
      return { cover: cover, isExact: isExact, diff: diff };
    });

    scored.sort(function (a, b) {
      if (a.isExact && !b.isExact) return -1;
      if (!a.isExact && b.isExact) return 1;
      return a.diff - b.diff;
    });

    state.hasSearched = true;
    el.findBtn.textContent = settings.updateText || "Update Results";

    el.resultsSummary.textContent =
      "For " +
      ratioLabel +
      ", " +
      w +
      " cm wingspan -- " +
      scored.length +
      " cover" +
      (scored.length !== 1 ? "s" : "") +
      " available";

    while (el.resultsGrid.firstChild) el.resultsGrid.removeChild(el.resultsGrid.firstChild);

    scored.forEach(function (item, i) {
      el.resultsGrid.appendChild(createCard(item.cover, i === 0));
    });

    el.results.classList.add("is-visible");
    el.placeholder.style.display = "none";

    if (window.innerWidth < 900) {
      el.results.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  /* ---------------------------------------------------------------
   * Product card builder
   * --------------------------------------------------------------- */
  function createCard(product, isBestFit) {
    var card = document.createElement("div");
    card.className = "product-card" + (isBestFit ? " is-best-fit" : "");

    if (isBestFit) {
      var badge = document.createElement("span");
      badge.className = "product-card__badge";
      badge.textContent = "Best Fit";
      card.appendChild(badge);
    }

    var img = document.createElement("img");
    img.src = product.image;
    img.alt = product.title;
    img.className = "product-card__image";
    img.loading = "lazy";
    if (product.imageWidth) img.width = product.imageWidth;
    if (product.imageHeight) img.height = product.imageHeight;
    if (product.image) {
      img.srcset = product.image.replace(/width=\d+/, "width=400") + " 400w, " + product.image + " 600w";
      img.sizes = "(max-width: 600px) 400px, 600px";
    }
    card.appendChild(img);

    var content = document.createElement("div");
    content.className = "product-card__content";

    var range = document.createElement("span");
    range.className = "product-card__range" + (isBestFit ? " product-card__range--accent" : "");
    range.textContent = product.aspectRatio.replace("-", " ");
    content.appendChild(range);

    var name = document.createElement("h3");
    name.className = "product-card__name";
    name.textContent = product.title;
    content.appendChild(name);

    if (product.specs) {
      var specs = document.createElement("p");
      specs.className = "product-card__specs";
      specs.textContent = product.specs;
      content.appendChild(specs);
    }

    var meta = document.createElement("div");
    meta.className = "product-card__meta";

    var price = document.createElement("span");
    price.className = "product-card__price";
    price.textContent = product.priceFormatted;
    meta.appendChild(price);

    var stockClass = "in";
    var stockText = "In Stock";
    if (!product.available) {
      stockClass = "out";
      stockText = settings.outOfStockText || "Out of Stock";
    } else if (product.inventory <= 10) {
      stockClass = "low";
      stockText = "Only " + product.inventory + " left";
    }

    var stock = document.createElement("span");
    stock.className = "product-card__stock product-card__stock--" + stockClass;
    var dot = document.createElement("span");
    dot.className = "product-card__stock-dot";
    stock.appendChild(dot);
    stock.appendChild(document.createTextNode(stockText));
    meta.appendChild(stock);

    content.appendChild(meta);
    card.appendChild(content);

    var actions = document.createElement("div");
    actions.className = "product-card__actions";

    if (product.available) {
      var atcBtn = document.createElement("button");
      atcBtn.className = "product-card__atc";
      atcBtn.type = "button";
      atcBtn.dataset.variantId = product.variantId;
      atcBtn.textContent = settings.addToCartText || "Add to Cart";
      atcBtn.addEventListener("click", function () {
        addToCart(this, product.variantId);
      });
      actions.appendChild(atcBtn);
    }

    var viewLink = document.createElement("a");
    viewLink.href = product.url;
    viewLink.className = "product-card__link";
    viewLink.textContent = "View Details";
    actions.appendChild(viewLink);

    card.appendChild(actions);
    return card;
  }

  /* ---------------------------------------------------------------
   * Add to cart via AJAX
   * --------------------------------------------------------------- */
  function addToCart(btn, variantId) {
    var originalText = btn.textContent;
    btn.textContent = "Adding...";
    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart error");
        return res.json();
      })
      .then(function () {
        btn.textContent = settings.addedText || "Added!";
        btn.style.background = "#2e7d32";
        setTimeout(function () {
          btn.textContent = originalText;
          btn.style.background = "";
          btn.disabled = false;
        }, 2000);
        /* Dispatch cart refresh for Impact theme (updates badge + drawer) */
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch(function () {
        btn.textContent = "Error";
        btn.style.background = "#C8102E";
        setTimeout(function () {
          btn.textContent = originalText;
          btn.style.background = "";
          btn.disabled = false;
        }, 2000);
      });
  }

  /* ---------------------------------------------------------------
   * Reset
   * --------------------------------------------------------------- */
  function reset() {
    state.wingspan = settings.wingspanDefault || 60;
    state.hasSearched = false;
    state.ratio = "High-aspect";
    el.wingspanSlider.value = state.wingspan;
    ratioPills.forEach(function (p) {
      p.classList.remove("is-active");
      p.setAttribute("aria-pressed", "false");
    });
    ratioPills[0].classList.add("is-active");
    ratioPills[0].setAttribute("aria-pressed", "true");
    updateDisplay();
    positionTooltip();
    buildQuickButtons();
    el.results.classList.remove("is-visible");
    el.placeholder.style.display = "";
    el.findBtn.textContent = settings.ctaText || "Find My Wing Cover";
  }

  /* Boot */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
